import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';
import { Cue5050DetailView } from '../../_models/fundraising/Cue5050';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    templateUrl: './ppw-details-modal.component.html',
    styleUrls: ['./ppw-details-modal.component.css']
  })

export class PledgePerWinDetailsModalComponent implements OnInit {

    public loading = false;
    public ppwId: number;

    public form: FormGroup;

    public viewRef: ViewContainerRef;

    constructor(
        private bsModalRef: BsModalRef,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private cue5050Service: Cue5050Service,
        private currencyPipe: CurrencyPipe,
        private datePipe: DatePipe
      ) { }

    ngOnInit(){
        this.initForm({
            eventName: 'Dummy event',
            eventCoordinator: 'Dummy coordinator',
            beneficiary: 'Dummy team',
            startDate: new Date(Date.now()),
            endDate: new Date(Date.now()),
            grossSales: 1000,
            cueFees: 100,
            expenses: 100,
            cardFees: 100,
            payouts: []
        })
    }

    initForm(ppwDetails: any){
        this.form = this.fb.group({
          eventName: [ppwDetails.eventName],
          eventCoordinator: [ppwDetails.eventCoordinator],
          beneficiary: [ppwDetails.beneficiary],
          startDate: [this.datePipe.transform(ppwDetails.startDate, 'MM-dd-yyyy')],
          endDate: [this.datePipe.transform(ppwDetails.endDate, 'MM-dd-yyyy')],
          grossSales: [this.currencyPipe.transform(ppwDetails.grossSales / 100)],
          cueFees: [this.currencyPipe.transform(ppwDetails.cueFees / 100)],
          expenses: [this.currencyPipe.transform(ppwDetails.expenses / 100)],
          cardFees: [this.currencyPipe.transform(ppwDetails.cardFees / 100)],
          payouts: [ppwDetails.payouts.map(p => { 
            return {
              amount: p.amount ? this.currencyPipe.transform(p.amount / 100) : 'N/A',
              arrivalDate: p.arrivalDate ? this.datePipe.transform(p.arrivalDate, 'MM-dd-yyyy') : 'N/A',
              description: p.description ?? 'N/A',
              type: p.type ?? 'N/A',
              status: p.status ?? 'N/A'
            }
          })]
        });
        
        this.form.disable();
    }

    close() {
      this.bsModalRef.hide();
    }
}